import React from 'react';

import { Stack, ActionBar, Divider } from '@gogame/components';
import { useDateRangeFormat } from '@gogame/intl-ts';

import { BreadcrumbsBar } from 'scenes/Trackers/components/Breadcrumbs';

import HourlyTrackerActions from './Actions';
import { HourlyTrackerPathBuilder } from './PathBuilder';
import {
  useLoadDimensions,
  useLoadDrillTo,
} from 'scenes/Trackers/HourlyTracker/data';
import { useScreenState } from '@gogame/screens';
import { isHourDimension } from 'scenes/Trackers/HourlyTracker/utils';
export default function ({
  nextLevel,
  onChangeNextLevel,
  drillItems,
  onChangeDrillPath,
  isDisabledExport,
}) {
  const { drillPath } = useScreenState();
  const { data: drillTo } = useLoadDrillTo({ drillPath });

  const { data: dimensions } = useLoadDimensions({ drillPath });
  const format = useDateRangeFormat({ timeZone: 'utc', template: 'LLL' });
  const drillEntityNameFormatter = ({ drillEntityName, dimensionId }) => {
    let v = drillEntityName;
    if (isHourDimension(dimensionId)) {
      let range = drillEntityName.split('|');
      if (range.length) {
        v = format(range).join(' - ');
      } else {
        v = '';
      }
    }

    return v ? v : 'All';
  };
  return (
    <React.Fragment>
      <Stack sx={{ width: '100%' }}>
        <ActionBar
          secondaryActions={
            <HourlyTrackerActions disabledExport={isDisabledExport} />
          }
        >
          <HourlyTrackerPathBuilder
            dimensions={dimensions}
            drillTo={drillTo}
            nextLevel={nextLevel}
            onChangeNextLevel={onChangeNextLevel}
          />
        </ActionBar>
        {drillItems?.length > 1 && (
          <BreadcrumbsBar
            value={drillItems}
            onChange={onChangeDrillPath}
            drillEntityNameFormatter={drillEntityNameFormatter}
          />
        )}
      </Stack>
      <Divider />
    </React.Fragment>
  );
}
